import trackEvent from '@/common/js/track.js'

// 新版券包落地页页面曝光
export function membershipLandingSw (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_membership_landing_sw',
    eventLabel: '新版券包落地页页面曝光',
    attrs,
    callback
  })
}

// 新版券包落地页点击
export function membershipLandingCk (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_membership_landing_ck',
    eventLabel: '新版券包落地页点击',
    attrs,
    callback
  })
}
